/**
 * The -48 V DC systems: rectifiers that report the DC load they carry (`dc_load_power`). A charger
 * that does not is not one. The one test the DC screens, the Power flow and the single line share
 * (`dc-chain.ts`); in a module of its own so `data-centre.ts` can read it without a cycle.
 */
import type { LatestRow } from '@/lib/api/types';

export function dcSystemIds(rows: readonly LatestRow[], devices: ReadonlyArray<{ id: number; role: string | null }>): number[] {
  const withLoad = new Set(rows.filter((r) => r.baseKey === 'dc_load_power').map((r) => r.deviceId));
  return devices.filter((d) => d.role === 'rectifier' && withLoad.has(d.id)).map((d) => d.id);
}
